import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { localizedPath } from 'gatsby-theme-i18n/src/helpers';
import { navigate } from 'gatsby';

import styled from 'styled-components';
import { MDXRenderer } from 'gatsby-plugin-mdx';

const SubmenuContainerMobile = styled.div`
  display: flex;
  flex-direction: column;
`;

const MenuItems = styled.div`
  color: var(--color-teal);
  font-size: 18px;
  
  & h4 {
    margin: 0;
    font-weight: 500;

    & p {
      color: var(--color-teal);
      margin: 0;
      padding: 10px 14px;
      color: var(--color-teal);
      white-space: pre-wrap;
    }
  }

  & :hover {
    background-color: var(--color-teal);
    color: var(--color-white);
    cursor: pointer;
  }

  &:first-child {
    padding-top: 10px;
  }

  @media (max-width: 550px) {
    font-size: 16px;
  }
`;

export default class SubmenuMobile extends Component {
  static propTypes = {
    subpages: PropTypes.arrayOf(PropTypes.object),
    locale: PropTypes.string,
    data: PropTypes.object,
  };

  render() {
    const { subpages, locale, data } = this.props;

    return (
      <SubmenuContainerMobile>
        {subpages?.map((item, index) => (
          <MenuItems
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            onClick={() => {
              navigate(localizedPath({
                locale,
                path: `/${data?.node?.frontmatter?.urlPath}/${item?.node?.frontmatter?.title}`,
                defaultLang: 'de',
                prefixDefault: false,
              }));
            }}
          >
            <h4>
              <MDXRenderer>{item?.node?.frontmatter?.submenuSubheadline}</MDXRenderer>
            </h4>
          </MenuItems>
        ))}
      </SubmenuContainerMobile>
    );
  }
}
